import React, { useState } from "react";
import "./layout.css";

import MyProjects from "../../assets/Images/MyProjects.png";
import MyProjectsw from "../../assets/Images/MyProjectsw.png";

import MyApproval from "../../assets/Images/MyApproval.png";
import MyApprovalw from "../../assets/Images/MyApproval.png";

import Setting from "../../assets/Images/setting.png";
import Logout from "../../assets/Images/logout.png";

import logo from "../../assets/Icons/logo.png";

import { NavLink } from "react-router-dom";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";

const SideBarWP = () => {
  const [urls, setUrls] = useState("dashboard");
  return (
    <div style={{ height: "100%", background: "#FFF" }} id="custom">
      <div className="container px-0">
        <div className="row">
          <div className=" sticky-top">
            <div className="d-flex flex-sm-column flex-row flex-nowrap  align-items-center sticky-top">
              <a
                href="/"
                className="d-block p-1 mt-3 link-dark text-decoration-none"
                title=""
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                data-bs-original-title="Icon-only"
              >
                <img src={logo} style={{ width: 160 }} />
              </a>
              <ul className="nav nav-pills nav-flush flex-sm-column mt-5 flex-row flex-nowrap mb-auto mx-auto text-center justify-content-between w-100 px-0 align-items-center">
                {/* <li className="nav-item" data-tooltip-id="dashboard" data-tooltip-content="Dashboard">
                                    <NavLink onClick={()=>{setUrls("dashboard")}} activeclassname='inactive' to="/" className="nav-link py-1 px-4 mx-0" title="" data-bs-toggle="tooltip" data-bs-placement="right" data-bs-original-title="Home">
                                     <div className={`d-flex ${urls==='dashboard'?'active-navs':""}`}>
                                      <div className=''>
                                       <img src={urls==="dashboard"?dashboardw:dashboard} style={{ width: 15,marginLeft:6 }} /> 
                                       </div>&nbsp;&nbsp;
                                       <div  className='navLink-cus my-1' style={{color:urls==='dashboard'?"white":"rgba(95, 95, 95, 1)"}}>Dashboard</div>
                                     </div>
                                    </NavLink>
                                </li> */}
                <li
                  className="nav-item mt-2"
                  data-tooltip-id="MyTasks"
                  data-tooltip-content="MyTasks"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("MyTasks");
                    }}
                    activeclassname="inactive"
                    to="/my-tasks"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "MyTasks" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        &nbsp;
                        <img
                          src={urls === "MyProjects" ? MyProjectsw : MyProjects}
                          style={{ width: 15 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "MyTasks"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        My Tasks
                      </div>
                    </div>
                  </NavLink>
                </li>
              </ul>

              <ul id="lb" className="nav nav-pills ">
                <li
                  className="nav-item mt-2"
                  data-tooltip-id="MyApproval"
                  data-tooltip-content="MyApprova1l"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("MyApproval1");
                    }}
                    activeclassname="inactive"
                    to="/my-approval"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "MyApproval1" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        &nbsp;
                        <img
                          src={urls === "MyApproval1" ? Setting : Setting}
                          style={{ width: 15 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "MyApproval1"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        Setting
                      </div>
                    </div>
                  </NavLink>
                </li>

                <li
                  className="nav-item mt-2"
                  data-tooltip-id="MyApproval1"
                  data-tooltip-content="MyApproval1"
                >
                  <NavLink
                    onClick={() => {
                      setUrls("MyApproval1");
                    }}
                    activeclassname="inactive"
                    to="/my-approval"
                    className="nav-link py-1 px-4 mx-0"
                    title=""
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    data-bs-original-title="Home"
                  >
                    <div
                      className={`d-flex ${
                        urls === "MyApproval1" ? "active-navs" : ""
                      }`}
                    >
                      <div className="">
                        &nbsp;
                        <img
                          src={urls === "MyApproval1" ? Logout : Logout}
                          style={{ width: 15 }}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className="navLink-cus my-1"
                        style={{
                          color:
                            urls === "MyApproval1"
                              ? "white"
                              : "rgba(95, 95, 95, 1)",
                        }}
                      >
                        Logout
                      </div>
                    </div>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBarWP;
